import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=3c985d75&scoped=true"
import script from "./Estoque.vue?vue&type=script&lang=js"
export * from "./Estoque.vue?vue&type=script&lang=js"
import style0 from "./Estoque.vue?vue&type=style&index=0&id=3c985d75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c985d75",
  null
  
)

export default component.exports